<template>
	<div :class="data.modal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
       <header class="modal-card-head">
      </header>
      <section class="modal-card-body ph20 has-text-centered ">
        <img v-if="vg_businessLoyality.branding && vg_businessLoyality.branding.logo_url" :src="vg_businessLoyality.branding.logo_url" alt="logo" class="mb20">
        <div :class="'loyality-congratulations-wrap relative' + (active ? ' active' : '') ">
          <div class="loyality-congratulations-point-wrap">
            <img src="@/assets/img/loyality_round_bg.png" alt="loyality icon"/>
            <span :class="'point-added' + ( parseInt(data.point) > 9999 ? ' sm' : '')">+{{ data.point }}</span>
          </div>
          <p class="is-size-1 point-text">Points</p>
          <p class="is-size-6 mb15 has-text-weight-semibold point-greeting">{{ data.message }}</p>
          <p class="is-size-6 has-text-weight-semibold">You are a rockstar, keep it up!</p>
          <img class="loyality-stars" src="@/assets/img/hurray.png" alt=""/>
        </div>
       
      <!-- form end -->
      </section>
      <footer class="modal-card-foot">
        <div class="next-prev-button">
          <button class="button is-large bg-secondary text-white hover-opacity-7 is-full-width" @click.prevent="close()">CONTINUE</button>
        </div>
      </footer>

    </div>
	</div>

</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      active: false,
      data: {
        modal: false,
        point: 0,
        message: "You've checked in!",
      }
    };
  },

  computed: {
    ...mapGetters({
      vg_businessProfile: "businessprofile/detail", 
      vg_businessLoyality: "businessprofile/businessLoyality", 
    }),
  },
  watch: {
    'data.modal'(val) {
      if(val){
        // lets delay the animation
        setTimeout(() => {
          this.active = true;
        }, 1000)
      } else {
        this.active = false;
      }
    },
  },

  mounted() {
    bus.$on('loyality-signup-congratulations', (payload) => {
      this.data = payload;
    })
  },
  
  beforeDestroy() {
    bus.$off('loyality-signup-congratulations');
  },

  methods: {
   
    /**
     * Close modal
     */
    close() {
      this.data = {
        modal: false,
        point: 0,
        message: '',
      };
    },

    ...mapActions({
      
    })

  },
};
</script>
<style scoped>
.loyality-congratulations-point-wrap {
    position: relative;
}
.site-wrapper .modal .loyality-congratulations-point-wrap span.point-added {
    position: absolute;
    color: #fff !important;
    font-weight: 800;
    font-size: 60px;
    text-align: center;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.site-wrapper .modal .loyality-congratulations-point-wrap span.point-added.sm{
  font-size: 48px;
}
.point-text {
  line-height: initial;
  position: relative;
  top: -15px; 
}
.site-wrapper .modal p.point-greeting,
.site-wrapper .modal p.point-text{
  color: #445232 !important;
}
.loyality-congratulations-wrap{
  overflow: hidden;
}
.loyality-stars {
  position: absolute;
  visibility: hidden;
  bottom: -400px;
  width: 100%;
  left: 0;
  transition: 0.4s ease-in-out;
  pointer-events: none;
}
.active .loyality-stars {
  visibility: visible;
  transition: 0.4s ease-in-out;
  animation-iteration-count: infinite;
  /* bottom: 40px; */
  animation-name: myanimate;
  animation-duration: 5s;
  animation-timing-function: cubic-bezier(0.25,0.1,0.25,1);
}
@keyframes myanimate {
  0%   { bottom: -400px; transform: scale(1.1);}
  40%  { bottom:  150px; transform: scale(1.1);}
  90%  { bottom: -400px; transform: scale(1.1);}
  100% { bottom: -400px; transform: scale(1.1);}
}


</style>